/**
 * Cliente ePOS-Print (Epson) por RED — camino SILENCIOSO y MULTIPLATAFORMA (PC, Android,
 * iPad) porque es solo `fetch` HTTPS a la impresora, sin agente local. Manda el payload
 * ESC/POS crudo vía el elemento `<command>` (hex) del ePOS-Print XML.
 *
 * Requiere hardware compatible (Epson TM-m30 y familia) con ePOS-Print activado en el
 * puerto SSL 8043. Caveat conocido: la TM trae un certificado autofirmado → el navegador
 * puede bloquear el primer `fetch` hasta que se confíe el cert una vez (se explica en la
 * pantalla de configuración).
 */

function toHex(payload: string): string {
  let out = '';
  for (let i = 0; i < payload.length; i++) out += (payload.charCodeAt(i) & 0xff).toString(16).padStart(2, '0');
  return out;
}

/** Imprime `escposLatin1` (bytes ESC/POS) en la impresora ePOS de `host:port`. Lanza si falla. */
export async function eposPrint(
  host: string,
  port: number | null,
  escposLatin1: string,
  timeoutMs = 10000,
): Promise<void> {
  if (!host) throw new Error('Falta el host/IP de la impresora de red.');
  const hex = toHex(escposLatin1).toUpperCase();
  const xml =
    `<?xml version="1.0" encoding="utf-8"?>` +
    `<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/"><s:Body>` +
    `<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">` +
    `<command>${hex}</command>` +
    `</epos-print></s:Body></s:Envelope>`;
  const url = `https://${host}:${port || 8043}/cgi-bin/epos/service.cgi?devid=local_printer&timeout=${timeoutMs}`;

  const ctrl = new AbortController();
  const t = window.setTimeout(() => ctrl.abort(), timeoutMs + 2000);
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'text/xml; charset=utf-8', SOAPAction: '""' },
      body: xml,
      signal: ctrl.signal,
    });
    if (!res.ok) throw new Error(`ePOS respondió HTTP ${res.status}`);
    const text = await res.text();
    if (/success="false"/i.test(text)) {
      const code = /code="([^"]*)"/i.exec(text)?.[1] || 'desconocido';
      throw new Error(`La impresora rechazó la impresión (code=${code}).`);
    }
  } catch (e: any) {
    if (e?.name === 'AbortError') throw new Error('La impresora de red no respondió (timeout).');
    throw e;
  } finally {
    window.clearTimeout(t);
  }
}
